import { updateState } from '../../../../home24/helpers/custom-elements';
import AddressCheckViewController from '../../../helpers/addressCheck/addressCheckViewController';
import AddressFormView from '../../../pages/myAccount/profile/addressFormView';
import BaseView from '../../../pages/myAccount/profile/BaseView';

export default BaseView.extend({
  events: {
    'click .edit-address-btn': 'onEditAddressButtonClick',
    'click .js-myaccount-address-new': 'onNewAddressButtonClick',
    'change [id^=myaccount-bill-address-], [id^=myaccount-delivery-address-]':
      'onCheckboxChange'
  },

  lightboxesConfig: {
    newAddressLightbox: {
      selector: '.js-new-address-lightbox',
      className: 'myaccount-address-lightbox-spacer',
      viewClass: AddressFormView
    }
  },

  /**
   * @param {Event} event
   */
  onNewAddressButtonClick: function(event) {
    var addressCheck = null;

    event.preventDefault();

    this.openLightboxByName('newAddressLightbox', null, function() {
      if (addressCheck) {
        addressCheck.closeSubViews();
      }
    });

    addressCheck = new AddressCheckViewController({
      el: $('#new_address-message-box form'),
      scope: $('body')
    });
  },

  /**
   * @param {Event} event
   */
  onEditAddressButtonClick: function(event) {
    event.preventDefault();

    var addressCheck = null;
    var lightboxId =
      '#' + $(event.currentTarget).prop('id') + '-message-lightbox';

    this.openLightboxUsingOptions(
      {
        selector: lightboxId,
        className: 'myaccount-address-lightbox-spacer',
        viewClass: AddressFormView
      },
      function() {
        if (addressCheck) {
          addressCheck.closeSubViews();
        }
      }
    );

    addressCheck = new AddressCheckViewController({
      el: $('.lightbox-dialog form[class=myaccount-contact-form]'),
      scope: $('body')
    });
  },

  onCheckboxChange: function(event) {
    var checkBoxType = event.currentTarget.id.split('-');
    var $otherCheckedCheckboxes = this.$el
      .find(
        '[id^=' +
          checkBoxType[0] +
          '-' +
          checkBoxType[1] +
          '-' +
          checkBoxType[2] +
          ']' +
          ':checked'
      )
      .not('#' + event.currentTarget.id);

    // if selected
    if (event.currentTarget.checked === true) {
      // unselect others
      $otherCheckedCheckboxes.prop('checked', false);
    } else {
      // if the only one selected
      if ($otherCheckedCheckboxes.length === 0) {
        // do not allow to uncheck it
        this.$el.find('#' + event.currentTarget.id).prop('checked', true);
      }
    }

    updateState();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/profile/ChangeListOfAddressesView.js
 **/